<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  styleClass="!w-[720px] !max-w-[95vw] !max-h-[90vh] flex flex-col overflow-hidden"
  contentStyleClass="!p-0 !overflow-hidden flex flex-col flex-1 min-h-0"
  (onHide)="onHide()"
>
  <router-outlet name="dialog" />
</p-dialog>
